<template>
  <div id="app">
    <component :is="layout">
      <router-view/>
    </component>
    <PortalTarget name="popup" multiple></PortalTarget>
  </div>
</template>
<script>
// import innerHeight from 'ios-inner-height'
// import disableScroll from './utils/disableScroll'

export default {
  name: 'App',
  metaInfo: {
    title: 'Главная',
    titleTemplate: 'Урок цифры',
  },
  computed: {
    layout() {
      return this.$route.meta.layout || 'default-layout'
    },
  },
  mounted() {
    // window.addEventListener('resize', this.resize)
    setInterval(this.resize, 200)
  },
  methods: {
    resize() {
      const html = document.documentElement
      html.style.setProperty('--vvh', `${window.innerHeight / 100}px`)
      document.addEventListener('touchmove', this.preventScroll, { passive: false })
    },
    preventScroll(e) {
      const disabledSelector = '.allow-scroll'

      if (this.$mq !== 'sm') return e

      const { target } = e
      if (target.classList.contains(disabledSelector) || target.closest(disabledSelector)) {
        return e
      }

      e.preventDefault()
      return false
    },
  },
}
</script>
<style lang="scss">
  @import './styles/main.scss';
</style>
